import * as infinityPlanData from "../../../../ds/infinityPlan.json";
import PlanOverviewMob from "./PlanOverviewMob";
import * as React from "react";
import IPlan from "../IPTypes";
import {IPContext} from "../../infinityPlan";

export default function PlansPricingMob() {
    const {plans,setShowAllPlan,setSelectedPlan} = React.useContext(IPContext);
    return (
        <ul className="plans_grid">
            {plans.map((plan: IPlan, index: number) => (
                <li className={plan.color} key={index}>
                    {PlanOverviewMob(plan)}
                    <div className="row row5 btnRow">
                        <button
                            className="link_button"
                            onClick={() => {
                                setShowAllPlan(true);
                                setSelectedPlan(plan);
                            }}
                        >
                            View All details
                        </button>
                    </div>
                </li>
            ))}

        </ul>
    );
}
